export default {"src":"/_next/static/media/arrow_down.af445425.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};